import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

import LinkOut from "./component/LinkOut"
import Page from "./component/Page"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper"

// Services
import {
  CreateContent,
  GetContentById,
  UpdateContent,
} from "./services/Services.js"

import {
  SearchPageSetting,
  SearchPageDetail,
  SavePageDetail,
  UpdatePageDetail,
} from "../../services/api/module/PageSetting.js"

import configWebRoute from "services/api/configWebRoute"
import Error401 from "components/Error401"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS

const _routeLink = `what-we-do/content-card-list`
const _pageName = `Content Card`
const _parentComponent = configWebRoute.WHAT_WE_DO
const slugType = "page"
const _routePermission = `what-we-do:content-card-list`

const ContentCardTemplate = ({ pageView = "create", componentKey = "" }) => {
  // POPUP
  const { mAlert } = useContext(ModalContext)

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? "TH"
  const qMainId = qParams.id
  const navigate = useNavigate()

  const [waitSendData, setWaitSendData] = useState(false)
  const [contentLoading, setContentLoading] = useState(false)
  const [contentDetail, setContentDetail] = useState()
  const [pageDetail, setPageDetail] = useState()
  const [prefillComplete, setPrefillComplete] = useState()
  const [list, setList] = useState([])
  const [pageType, setPageType] = useState()

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    businessName: Yup.string().max(255).required("Please Enter Business name"),

    contentLinkout: Yup.string().when("pageType", (pageType = "") => {
      return pageType == "link-out"
        ? Yup.string().required("Please Enter Link Out")
        : Yup.string().notRequired()
    }),

    homeThumbnail: Yup.object().when("pageType", (pageType = "") => {
      return Yup.object()
        .test(
          "is-not-empty-object",
          "Please Upload Home Thumbnail",
          value => value && Object.keys(value).length > 0
        )
        .required()
    }),
    thumbnail: Yup.object().when("pageType", (pageType = "") => {
      return pageType == "link-out"
        ? Yup.object()
            .test(
              "is-not-empty-object",
              "Please Upload thumbnail",
              value => value && Object.keys(value).length > 0
            )
            .required()
        : Yup.object().notRequired()
    }),
    imageDescription: Yup.object().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.object()
            .test(
              "is-not-empty-object",
              "Please Upload Image Description",
              value => value && Object.keys(value).length > 0
            )
            .required()
        : Yup.object().notRequired()
    }),

    slug: Yup.string().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.string().required("Please Enter Slug")
        : Yup.string().notRequired()
    }),

    contentDetail: Yup.string().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.string().required("Please Enter Business description")
        : Yup.string().notRequired()
    }),

    descriptionHeader: Yup.string().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.string().required("Please Enter Business header")
        : Yup.string().notRequired()
    }),

    contentSeoTitle: Yup.string().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.string().max(255).required("Please Enter Title")
        : Yup.string().notRequired()
    }),

    contentSeoKeyword: Yup.string().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.string().max(1024)
        : Yup.string().notRequired()
    }),

    contentSeoDescription: Yup.string().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.string().max(1024)
        : Yup.string().notRequired()
    }),

    bannerDesktop: Yup.object().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.object()
            .test(
              "is-not-empty-object",
              "Please Upload Banner Desktop",
              value => value && Object.keys(value).length > 0
            )
            .required()
        : Yup.object().notRequired()
    }),

    bannerMobile: Yup.object().when("pageType", (pageType = "") => {
      return pageType == "page"
        ? Yup.object()
            .test(
              "is-not-empty-object",
              "Please Upload Banner Mobile",
              value => value && Object.keys(value).length > 0
            )
            .required()
        : Yup.object().notRequired()
    }),

    contentUpdateDate: Yup.string()
      .max(100)
      .required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),

    contentSeoTitle: Yup.string(),
    contentSeoKeyword: Yup.string().max(1024),
    contentSeoDescription: Yup.string().max(1024),
    // gallery: Yup.object().test(
    //   "is-not-empty-object",
    //   "Please Upload Gallery",
    //   (value) => value && Array.isArray(value) && value.length === 0
    // ).required("Please Upload Gallery"),

    // contentSeoTitle: Yup.string().required("Please Enter Meta Title"),
    // contentSeoKeyword: Yup.string()
    //   .max(1024)
    //   .required("Please Enter Meta keyword"),
    // contentSeoDescription: Yup.string()
    //   .max(1024)
    //   .required("Please Enter Meta Description"),
  })

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] =
    useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    businessName: "",
    contentDetail: "",
    descriptionHeader: "",
    bannerDesktop: {},
    bannerMobile: {},
    // gallery: [],
    thumbnail: {},
    homeThumbnail: {},
    imageDescription: {},

    contentLinkout: "",
    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format("YYYY-MM-DD"),
    contentStatus: "active",

    slug: "",
    pageType: "",
    // contentPageName: "",
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
      const payload = {
        id: qMainId,
        contentId: values.contentId ? values.contentId : undefined,
        langId: qLang,
        contentName: values.businessName,
        contentDetail: values.contentDetail,
        descriptionHeader: values.descriptionHeader,
        // gallery: values.gallery,
        bannerMobile: values.bannerMobile,
        contentLinkout: values.contentLinkout ? values.contentLinkout : null,

        pageType: values.pageType ? values.pageType : null,
        slug: values.slug ? values.slug.replace(/-+$/, "") : null,

        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        // attachmentData: {
        //   gallery: values.gallery,
        // },

        attachmentData: {},
        contentAttachmentData: {
          bannerDesktop: values.bannerDesktop,
          bannerMobile: values.bannerMobile,
          thumbnail: values.thumbnail,
          homeThumbnail: values.homeThumbnail,
          imageDescription: values.imageDescription,
        },

        // pageSettingRoute: {
        //   contentPageName: values.contentPageName,
        //   componentKey: componentKey
        // }
      }

      console.log(pageDetail)
      const pageDetailRoute = {
        mainId: pageDetail?.mainId ?? null,
        contentPageName: payload.contentName,
        slug: `${payload.slug}`,
        contentSeoTitle: values.contentSeoTitle ? values.contentSeoTitle : null,
        contentSeoKeyword: values.contentSeoKeyword
          ? values.contentSeoKeyword
          : null,
        contentSeoDescription: values.contentSeoDescription
          ? values.contentSeoDescription
          : null,
        componentKey: componentKey,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,
        _parentComponent: _parentComponent,
      }

      console.log("🚀 ~ onSave ~ payload:", payload)

      setWaitSendData(true)
      if (pageView === "update") {
        // API.fetchUpdateContent(payload)
        API.fetchUpdateContent(payload, pageDetailRoute)
      } else {
        API.fetchCreateContent(payload, pageDetailRoute)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("businessName", resData?.contentName ?? "")
    validation.setFieldValue("pageType", resData?.pageType ?? "")

    // if(!resData?.pageType) {
    //   setPageType("link-out")

    //   validation.setFieldValue(
    //     "pageType",
    //     "link-out"
    //   )
    // }

    validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    validation.setFieldValue(
      "descriptionHeader",
      resData?.descriptionHeader ?? ""
    )
    validation.setFieldValue("contentLinkout", resData?.contentLinkout ?? "")

    // validation.setFieldValue("gallery", resData?.gallery ?? [])

    validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    validation.setFieldValue(
      "contentSeoKeyword",
      resData?.contentSeoKeyword ?? ""
    )
    validation.setFieldValue(
      "contentSeoDescription",
      resData?.contentSeoDescription ?? ""
    )

    validation.setFieldValue(
      "contentUpdateDate",
      resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
    )
    validation.setFieldValue(
      "contentStatus",
      resData?.contentStatus ?? "active"
    )
    validation.setFieldValue("slug", resData?.slug ?? "")

    // validation.setFieldValue("contentPageName", resData?.pageSettingRoute?.contentPageName ?? "")
    // validation.setFieldValue("slug", resData?.pageSettingRoute?.slug ?? "")

    validation.setFieldValue(
      "thumbnail",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "thumbnail"
      ) ?? ""
    )
    validation.setFieldValue(
      "homeThumbnail",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "home_thumbnail"
      ) ?? ""
    )
    validation.setFieldValue(
      "imageDescription",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "image_description"
      ) ?? ""
    )
    validation.setFieldValue(
      "bannerDesktop",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "banner_desktop"
      ) ?? ""
    )
    validation.setFieldValue(
      "bannerMobile",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "banner_mobile"
      ) ?? ""
    )

    setContentDetail(resData)
    setPrefillComplete(true)

    if (resData?.pageType) {
      setPageType(resData?.pageType)
    } else {
      // setPageType('link-out')
      // validation.setFieldValue(
      //   "pageType",
      //   'link-out'
      // )
    }
  }

  // const preFilInputPage = (resData = {}) => {
  //   console.log("🚀 ~ preFilInputPage ~ resData:", resData)
  //   // resetForm(validation.values, initialValues)

  //   validation.setFieldValue("contentPageName", resData?.contentPageName ?? "")
  //   validation.setFieldValue("slug", resData?.slug ?? "")
  // }

  const API = {
    fetchGetPageDetail: async (componentKey, slug) => {
      const response = await SearchPageDetail(componentKey, {
        lang: qLang,
        params: {
          slug: slug,
        },
      })
      const resData = response.data
      if (resData.status == 200) {
        setPageDetail(resData.data)
      }
    },
    fetchGetContentPageSetting: async componentKey => {
      try {
        const response = await SearchPageSetting(componentKey, {
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          console.log("KZKB", resData.data)
          preFilInputPage(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },
    fetchGetContentById: async payload => {
      try {
        const response = await GetContentById({
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          preFilInput(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },
    fetchCreateContent: async (payload, pageDetailRoute) => {
      try {
        let responseP = {
          status: 201,
        }

        if (validation.values.pageType == "page") {
          responseP = await SavePageDetail(componentKey, {
            data: pageDetailRoute,
            lang: qLang,
          })
        }

        console.log(responseP)

        const response = await CreateContent({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201 && responseP.status == 201) {
          mAlert.info({
            title: "Alert",
            subTitle: "Created Data Success",
            content: "",
            onClose: () => {
              navigate(`/${_routeLink}/${qLang}/edit/${resData.data.mainId}`)
              window.location.reload()
            },
          })
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchUpdateContent: async (payload, pageDetailRoute) => {
      try {
        let responseP = {
          status: 202,
        }
        if (validation.values.pageType == "page") {
          responseP = await UpdatePageDetail(componentKey, {
            params: {},
            data: pageDetailRoute,
            lang: qLang,
          })
        }

        const response = await UpdateContent({
          data: payload,
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 202 && responseP.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              // navigate(`/${_routeLink}/${qLang}/edit`)
              // window.location.reload()
            },
          })
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id: qMainId }
      setContentLoading(true)
      API.fetchGetContentById(payload)
    }
  }, [qLang])

  useEffect(() => {
    if (
      ["update", "view"].includes(pageView) &&
      prefillComplete &&
      Object.keys(contentDetail).length > 0
    ) {
      const _pageDetail = API.fetchGetPageDetail(
        componentKey,
        `${contentDetail?.slug}`
      )
      setPageDetail(_pageDetail)
    }
  }, [prefillComplete, contentDetail])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title =
    `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: "10px",
    border: "1px solid black",
    margin: "5px",
    borderRadius: "8px",
    background: "#f9f9f9",
    transition: "transform 0.2s ease, background-color 0.3s ease",
  }

  const mapValues = (list = []) =>
    list.map(item => {
      const newObj = {
        attachmentId: item.attachmentId,
        sequence: item.sequence,
      }
      return newObj
    })

  if (
    !checkScope(`${_routePermission}:create`) ||
    !checkScope(`${_routePermission}:update`) ||
    !checkScope(`${_routePermission}:view`)
  ) {
    return <Error401 />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${PAGE_VIEW} ${_pageName}`}
            breadcrumbItems={[
              { title: _pageName, link: "" },
              { title: PAGE_VIEW },
            ]}
          />

          {/* Render Form */}
          {contentLoading ? (
            <Spinners setLoading={setContentLoading} />
          ) : (
            <Row>
              <Col className="col-12">
                <FormikProvider value={validation}>
                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col className="col-8">
                        <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">
                            <i className="bx bx-cube-alt"></i> Information Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <Label for="exampleSelect">Page Type</Label>
                                <Input
                                  id="pageType"
                                  className="form-control"
                                  type="select"
                                  placeholder=""
                                  name="pageType"
                                  onChange={e => {
                                    setPageType(e.target.value)
                                    validation.setFieldValue(
                                      "pageType",
                                      e.target.value
                                    )
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.pageType}
                                  invalid={
                                    validation.touched.pageType &&
                                    validation.errors.pageType
                                      ? true
                                      : false
                                  }
                                  // disabled={['update', 'view'].includes(pageView)}
                                >
                                  <option value=""></option>
                                  <option value="link-out">Link Out</option>
                                  <option value="page">Page</option>
                                </Input>
                                {validation.touched.pageType &&
                                  validation.errors.pageType && (
                                    <FormFeedback type="invalid">
                                      {validation.errors.pageType}
                                    </FormFeedback>
                                  )}
                                <hr />
                              </Col>

                              <Col className="col-12 mb-3">
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="ImageMap"
                                    upload="Image"
                                    prefixName="page-homeThumbnail"
                                    label="Home Image"
                                    required={true}
                                    description="description"
                                    widthSize={380}
                                    heightSize={480}
                                    value={validation.values.homeThumbnail}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "homeThumbnail",
                                        value
                                      )
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "homeThumbnail",
                                        {}
                                      )
                                    }}
                                  />
                                  {validation.touched.homeThumbnail &&
                                    validation.errors.homeThumbnail && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.homeThumbnail}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              {pageType == "link-out" && (
                                <LinkOut
                                  validation={validation}
                                  pageView={pageView}
                                />
                              )}
                              {pageType == "page" && (
                                <Page
                                  validation={validation}
                                  pageView={pageView}
                                />
                              )}
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col className="col-4">
                        <Card
                          outline
                          color="primary"
                          className="border sticky-element"
                        >
                          <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                            <i className="bx bx-check"></i> Tools Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Switch Language
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputLang
                                    widthfull
                                    pageView={pageView}
                                    forceRoute={false}
                                  />
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Written at
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputGroup>
                                    <Flatpickr
                                      className="form-control d-block"
                                      options={{
                                        dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                      }}
                                      value={
                                        validation.values.contentUpdateDate
                                          ? moment(
                                              validation.values
                                                .contentUpdateDate,
                                              "YYYY-MM-DD"
                                            ).toDate()
                                          : null
                                      }
                                      disabled={true}
                                    />
                                    <div className="input-group-append">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary docs-datepicker-trigger"
                                        disabled
                                      >
                                        <i
                                          className="fa fa-calendar"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    </div>
                                  </InputGroup>
                                  {validation.touched.contentUpdateDate &&
                                    validation.errors.contentUpdateDate && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentUpdateDate}
                                      </div>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Display
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Select
                                    placeholder="Select Status"
                                    value={fn_helper.FNFORM.getObjectValue(
                                      STATUS_OPTION,
                                      `${validation.values.contentStatus}`
                                    )}
                                    onChange={value =>
                                      validation.setFieldValue(
                                        "contentStatus",
                                        value.id
                                      )
                                    }
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.name}
                                    options={STATUS_OPTION}
                                    className={`select2-selection ${
                                      validation.touched.contentStatus &&
                                      validation.errors.contentStatus
                                        ? "input-err"
                                        : ""
                                    }`}
                                    isDisabled={pageView === "view"}
                                  />
                                  {validation.touched.contentStatus &&
                                    validation.errors.contentStatus && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentStatus}
                                      </div>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardFooter>
                            <Row>
                              <Col className="text-start">
                                <Button
                                  color="danger"
                                  className="btn btn-danger"
                                  onClick={() =>
                                    navigate(`/${_routeLink}/${qLang}`)
                                  }
                                >
                                  Back
                                </Button>
                              </Col>
                              <Col className="text-end">
                                {pageView !== "view" && (
                                  <Button
                                    type="submit"
                                    className="btn btn-success"
                                  >
                                    Save{" "}
                                    {waitSendData ? (
                                      <Spinner size="sm" color="light" />
                                    ) : null}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </CardFooter>
                        </Card>
                      </Col>
                    </Row>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(ContentCardTemplate)
